// swalHelper.js
import Swal from "sweetalert2";
import axios from "axios";

const checkCnicAndMobile = () => {
  return new Promise((resolve, reject) => {
    Swal.fire({
      title: "Please Verify CNIC and Mobile Number\n Enter CNIC Number and mobile number with DASHES AS \n CNIC (12345-6789123-4) \n Mobile Number (0300-1234567)",
      html: `
        <input type="text" id="cnic" class="swal2-input" placeholder="CNIC (12345-6789123-4)">
        <input type="text" id="mobile" class="swal2-input" placeholder="Mobile Number (0300-1234567)">
      `,
      showCancelButton: true,
      confirmButtonText: "Verify",
      cancelButtonText: "Cancel",
      showLoaderOnConfirm: true,
      preConfirm: () => {
        const cnic = document.getElementById("cnic").value;
        const mobile = document.getElementById("mobile").value;
        const cnicPattern = /^\d{5}-\d{7}-\d$/;
        const mobilePattern = /^\d{4}-\d{7}$/;

        if (!cnicPattern.test(cnic) || !mobilePattern.test(mobile)) {
          Swal.showValidationMessage("Invalid CNIC or Mobile Number format");
          reject(new Error("Invalid CNIC or Mobile Number format"));
        }

        return { cnic, mobile };
      },
      allowOutsideClick: () => !Swal.isLoading(),
    }).then((result) => {
      if (result.isConfirmed) {
        const { cnic, mobile } = result.value;
        axios
          .post("https://backend.form-seef.com/api/check-cnic-mobile", { cnic, mobile })
          .then((response) => {
            const data = response.data.data;
            console.log("data:", data);

            // Show congratulation window
            Swal.fire({
              title: "Congratulations!",
              text: "Verification successful. You can now upload your result.",
              showCancelButton: true,
              confirmButtonText: "Upload Result",
              cancelButtonText: "Cancel",
              showLoaderOnConfirm: true,
            }).then((uploadResult) => {
              if (uploadResult.isConfirmed) {
                // Handle the "Upload Result" button click
                Swal.fire({
                  title: "Upload Result \n JPG, JPEG, PNG FORMAT ONLY",
                  html: `
                    <input type="file" id="result_file" class="swal2-input" placeholder="Select a file">
                  `,
                  showCancelButton: true,
                  confirmButtonText: "Upload",
                  cancelButtonText: "Cancel",
                  showLoaderOnConfirm: true,
                  preConfirm: () => {
                    return new Promise((resolve, reject) => {
                      const resultFileInput = document.getElementById("result_file");
                      const result_file = resultFileInput.files[0];

                      // Check if a file is selected
                      if (!result_file) {
                        reject(new Error("The result file field is required."));
                      }

                      resolve();
                    });
                  },
                }).then(() => {
                  const resultFileInput = document.getElementById("result_file");
                  const result_file = resultFileInput.files[0];

                  // Create FormData and append fields
                  const formData = new FormData();
                  formData.append('cnic', cnic);
                  formData.append('mobile', mobile);
                  formData.append('result_file', result_file);

                  // Append additional data if available
                  if (data && data.personal && data.academic) {
                    // formData.append('personal_id', data.personal.id);
                    formData.append('first_name', data.personal.first_name);
                    formData.append('last_name', data.personal.last_name);
                    formData.append('father_name', data.personal.father_name);
                    formData.append('domicile_id', data.personal.domicile_id);
                    formData.append('roll_number', data.academic.roll_number);
                    formData.append('university_id', data.academic.university_id);
                    formData.append('discipline_id', data.academic.discipline_id);
                  }

                  // Log FormData entries
                  console.log("Data to Send to Backend:");
                  for (let pair of formData.entries()) {
                    console.log(pair[0] + ': ' + pair[1]);
                  }

                  // Uncomment the following block when you're ready to send the data to the server
                  
                  axios.post("https://backend.form-seef.com/api/results", formData)
                    .then(() => {
                      // Display success alert after successful upload
                      Swal.fire({
                        title: "Result Uploaded Successfully!",
                        icon: "success",
                        confirmButtonText: "OK",
                      });

                      resolve(); // Resolve the outer promise to indicate success
                    })
                    .catch((err) => {
                      reject(err);
                    });
                  
                });
              } else {
                reject(new Error("User canceled"));
              }
            });
          })
          .catch((err) => {
            Swal.fire({
              title: "Verification Failed",
              text: "CNIC and Mobile verification failed. Please try again.",
              icon: "error",
              confirmButtonText: "OK",
            });
            reject(err);
          });
      } else {
        reject(new Error("User canceled"));
      }
    });
  });
};

export default checkCnicAndMobile;
